import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getMyJobApplications, updateApplicationStatus } from '../../../../../../actions/jobs/jobs';

class StatusForm extends Component {
    state = {
        app_job: 0,
        error: false
    };

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    postJobStatus = (e) => {
        e.preventDefault();
        const { updateApplicationStatus, getMyJobApplications, options } = this.props,
            person_id = localStorage.getItem('person_id');
        if (this.state.app_job === 0) {
            return this.setState({ error: true });
        }
        updateApplicationStatus(person_id, this.state.app_job, this.props.job_id);
        getMyJobApplications(options, 1, person_id);
    };

    render() {
        const { statuses } = this.props;
        return (
            <React.Fragment>
                <div className="mt-1">
                    {this.state.error && (
                        <div className="alert alert-danger small">
                            Choose application status to update.
            </div>
                    )}
                </div>
                <form className="form-status-application">
                    <ul className="status-update">
                        <li className="status-update__input">
                            {
                                statuses && (
                                    <select
                                        className="form-control"
                                        name="app_job"
                                        onChange={this.onChange}
                                        defaultValue={1}
                                    >
                                        {statuses.map(status => {
                                            return <option key={status.name} value={status.id}>{status.name}</option>;
                                        })}
                                    </select>
                                )
                            }
                        </li>
                        <li className="status-update__button" style={{ width: '125px' }}>
                            <button className="theme-button" onClick={this.postJobStatus}>Update</button>
                        </li>
                    </ul>
                </form>
            </React.Fragment>
        );
    }
}

StatusForm.propTypes = {
    getMyJobApplications: PropTypes.func,
    updateApplicationStatus: PropTypes.func,
    job_id: PropTypes.number,
    options: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]),
    statuses: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        options: state.jobs.options
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMyJobApplications: (options, page, person_id, jobId) => dispatch(getMyJobApplications(options, page, person_id, jobId)),
        updateApplicationStatus: (personId, status, jobId) => dispatch(updateApplicationStatus(personId, status, jobId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(StatusForm);



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/StatusForm.js